import styled from "styled-components";

export const InfoSec = styled.div`
  position: relative;
  color: #fff;
  padding: 80px 5vw;

  @media screen and (max-width: 768px) {
    padding: 32px 20px 20px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};
`;

export const InfoColumn = styled.div`
  flex: 0 0 auto;
  width: 100%;

  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
`;

export const TextWrapper = styled.div`
  max-width: 620px;
  width: 100%;
  margin-left: 0;
  margin-right: auto;
  padding: 34px 38px 38px;
  border: 1px solid rgba(0, 194, 255, 0.2);
  border-radius: 28px;
  background:
    radial-gradient(circle at 12% 18%, rgba(0, 194, 255, 0.12), transparent 32%),
    linear-gradient(135deg, rgba(2, 11, 35, 0.62), rgba(3, 27, 69, 0.42));
  box-shadow:
    0 24px 70px rgba(0, 0, 0, 0.26),
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 0 34px rgba(0, 194, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding: 22px 18px 26px;
    border-radius: 18px;
    margin: 0 auto;
    text-align: center;
  }
`;

export const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
  justify-content: ${({ start }) => (start ? "flex-start" : "flex-end")};
`;

export const TopLine = styled.div`
  color: ${({ lightTopLine }) => (lightTopLine ? "#00C2FF" : "#2DAAE1")};
  font-size: 18px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  margin-bottom: 16px;
`;

export const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  max-height: 500px;
  border-radius: 28px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.32),
    0 0 36px rgba(0, 194, 255, 0.12);
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-family: "Poppins", "Inter", sans-serif;
  font-size: 52px;
  line-height: 1.1;
  font-weight: 800;
  color: ${({ lightText }) => (lightText ? "#00C2FF" : "#00C2FF")};
  font-style: normal;
  text-align: center;
  text-shadow:
    0 0 28px rgba(0, 194, 255, 0.24),
    0 2px 14px rgba(0, 0, 0, 0.28);

  @media screen and (max-width: 768px) {
    font-size: 26px;
  }
`;

export const Subtitle = styled.p`
  max-width: 500px;
  margin-bottom: 35px;
  font-size: 16px;
  line-height: 1.8;
  text-align: center;
  color: ${({ lightTextDesc }) =>
    lightTextDesc ? "rgba(248, 251, 255, 0.88)" : "rgba(248, 251, 255, 0.88)"};
  font-weight: 600;
  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.32);

  @media screen and (max-width: 768px) {
    font-size: 13px;
    line-height: 1.65;
    margin-bottom: 0;
    max-width: 100%;
  }
`;
